module.exports = __webpack_public_path__ + "img/0Q3A2198_L_Foamcore.10fef85f.jpg";